<form [formGroup]="filterSubjectForm" (ngSubmit)="onFiltering()">
  <div class="row">
    <div class="col-md-4 form-group">
      <label class="label-filter">{{this.lextranslate.i18n["4e7d56a3-8a46-452d-a4e8-6aae1b80c8ae"]}}</label>
      <input formControlName="Name" class="form-control" type="text" placeholder="{{lextranslate.i18n['4b678e23-6d40-4f2e-81c7-d7541820cc04']}}" />
    </div>
    <div class="col-md-6 col-lg-4 col-xl-1 form-group div-filter-button">
      <label class="transparent-label">{{this.lextranslate.i18n["d6ab9882-6001-4699-ae57-8ee49ce724a8"]}}</label>
      <button type="submit" class="btn btn-success btn-with-icon">
        <i class="material-icons">filter_list</i>
        <span class="span-with-icon">{{this.lextranslate.i18n["d6ab9882-6001-4699-ae57-8ee49ce724a8"]}}</span>
      </button>
    </div>

    <div class="col-md-6 col-lg-4 col-xl-1 div-clear-filter-button" *ngIf="existFilters">
      <label class="transparent-label">{{this.lextranslate.i18n["d6ab9882-6001-4699-ae57-8ee49ce724a8"]}}</label>
      <div style="position: relative;">
        <button type="button" class="clear-filter-button" (click)="clearFilter()" ngbTooltip="Limpar Filtros"
          placement="bottom">
          <i class="material-icons">delete_sweep</i>
        </button>
      </div>
    </div>
  </div>
</form>
